import type {
  ThematiqueGraffitiParams,
  ThematiqueGraffitiResponse,
  ThematiqueResponse,
  ThematiqueWithCountResponse,
} from '@/types/api'
import type { Thematique } from '@/types/entities'
import { apiGet } from './http'

// API des thématiques
export const thematiquesApi = {
  /**
   * Récupérer toutes les thématiques
   */
  async list(withCount = false): Promise<ThematiqueResponse | ThematiqueWithCountResponse> {
    console.log('[ThematiquesAPI] list - withCount:', withCount)

    const params = withCount ? { with_count: 'true' } : undefined

    if (withCount) {
      return apiGet<ThematiqueWithCountResponse>('/thematiques', params)
    } else {
      return apiGet<ThematiqueResponse>('/thematiques', params)
    }
  },

  /**
   * Récupérer les graffitis d'une thématique spécifique
   */
  async getGraffitis(
    thematiqueId: number,
    params?: ThematiqueGraffitiParams
  ): Promise<ThematiqueGraffitiResponse> {
    console.log('[ThematiquesAPI] getGraffitis - ID:', thematiqueId, 'params:', params)

    return apiGet<ThematiqueGraffitiResponse>(
      `/thematiques/${thematiqueId}/graffitis`,
      params as Record<string, string | number | undefined>
    )
  },

  /**
   * Récupérer toutes les thématiques sous forme de liste simple (pour compatibilité)
   */
  async getAll(): Promise<Thematique[]> {
    console.log('[ThematiquesAPI] getAll')
    const response = await this.list()
    return response.data
  },

  /**
   * Récupérer toutes les thématiques avec leur nombre de graffitis
   */
  async getAllWithCount(): Promise<Array<Thematique & { count?: number }>> {
    console.log('[ThematiquesAPI] getAllWithCount')
    const response = (await this.list(true)) as ThematiqueWithCountResponse
    return response.data
  },

  /**
   * Récupérer une thématique par son ID
   */
  async getById(id: number): Promise<Thematique | null> {
    console.log('[ThematiquesAPI] getById:', id)
    const allThematiques = await this.getAll()
    return allThematiques.find(t => t.idThem === id) || null
  },

  /**
   * Récupérer les noms de toutes les thématiques uniques (pour filtres)
   */
  async getUniqueNames(): Promise<string[]> {
    console.log('[ThematiquesAPI] getUniqueNames')
    const allThematiques = await this.getAll()
    const names = [
      ...new Set(allThematiques.map(t => t.thematique).filter((t): t is string => Boolean(t))),
    ]
    return names.sort()
  },
}
